import React from 'react';
import initState from './initState';

const RouteContext = React.createContext(initState);

export default RouteContext;
